import { SetStateAction, Dispatch } from 'react';
import { Link } from 'react-router-dom';
import classNames from 'classnames';
import { batch } from 'react-redux';

import { OptionalComponent } from '../../../utils/optional-component';
import { abortWorkingEventLoad, clearPublishedUrl, clearSelectedEvent, clearWorkingEvent } from '../../../store/actions/admin/create-event';
import { EPermissions } from '../../../types/working-model';
import Icon, { COLORS, ICONS } from '../../general-ui/icon';
import NavigationDropdown from '../../general-ui/dropdown/navigation-dropdown';
import { AuthWrapper } from '../authentication/AuthWrapper';
import { PATHNAMES } from '../../../utils/admin-routing-utils';
import { getCreateProjectUrl } from 'utils/utils';
import { useAppDispatch } from 'store/reducers/use-typed-selector';
import GradientButton from '@general-ui/button/gradient-button';
import { useProjectDetailsEnabled } from './hooks/project-details';
import { Button } from '@general-ui/button/button';

interface ICreateEventButton {
	setShowEventGroupModal?: Dispatch<SetStateAction<boolean>>;
}

const CreateEventButton = ({ setShowEventGroupModal }: ICreateEventButton) => {
	const dispatch = useAppDispatch();

	const projectDetailsFlagIsOn = useProjectDetailsEnabled();

	if (projectDetailsFlagIsOn) {
		return (
			<AuthWrapper allowedRoles={[EPermissions.GroupAdmin]}>
				<Button
					onClick={() => window.location.href = `${getCreateProjectUrl()}/choose`}
					classButton="create-button"
				>
					<Icon name={ICONS.ADD} color={COLORS.BLACK} size={12} />
					Create
				</Button>
			</AuthWrapper>
		);
	}

	return (
		<AuthWrapper allowedRoles={[EPermissions.GroupAdmin]}>
			<NavigationDropdown
				title="Create"
				buttonClassName="create-dropdown"
				renderCustomIcon={() => <Icon name={ICONS.ADD} color={classNames(COLORS.BLACK, "create-button-plus")} size={12} />}
			>
				<OptionalComponent display={!projectDetailsFlagIsOn}>
					<Link
						className="create-event"
						to={PATHNAMES.CreateEventFlowEntryPoint}
						onClick={() => {
							batch(() => {
								dispatch(clearSelectedEvent());
								dispatch(abortWorkingEventLoad());
								dispatch(clearWorkingEvent());
								dispatch(clearPublishedUrl());
							});
						}}
					>
						Project
					</Link>
				</OptionalComponent>
				<OptionalComponent display={!!setShowEventGroupModal}>
					<AuthWrapper>
						<div className="create-event-group" onClick={() => setShowEventGroupModal?.(true)}>
							Folder
						</div>
					</AuthWrapper>
				</OptionalComponent>
			</NavigationDropdown>
		</AuthWrapper>
	);
};

export default CreateEventButton;
